import { render, staticRenderFns } from "./FundsSettings.vue?vue&type=template&id=30b1cacd"
import script from "./FundsSettings.vue?vue&type=script&lang=js"
export * from "./FundsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports